module.exports = __webpack_public_path__ + "static/media/information.163d500c.svg";